import { Paper, styled, Box } from "@mui/material";
import { colors } from '../../../../../theme/colors';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export const FormContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: "1.5rem 2rem",
  overflowY: "auto",
  maxHeight: "100%",
  backgroundColor: "#f8fafc",
  boxSizing: "border-box",
  fontFamily:
    '"Public Sans Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f5f9",
    borderRadius: "3px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#cbd5e1",
    borderRadius: "3px",
    "&:hover": {
      background: colors.primary,
    },
  },
  "& .UploadImage": {
    width: "130px",
    height: "130px",
    borderRadius: "50%",
    color: "#919EAB",
    position: "relative",
    marginTop: "20px",
    marginBottom: "20px",
    cursor: "pointer",
    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
    transition: "transform 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.02)",
    },
  },
  "& .upload-placeholder": {
    position: "absolute",
    backgroundColor: colors.primary,
    boxShadow: `${colors.primary} 0px 3px 15px -3px`,
    borderRadius: "50%",
    top: "0px",
    left: "0px",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  "& .upload-placeholder_hover": {
    "&:hover": {
      opacity: 0.85,
    },
  },
  "& .file_format": {
    color: "#64748b",
    fontSize: "0.75rem",
    lineHeight: 1.4,
  },
  "& .upload-input": {
    display: "none",
  },
  "& .profile_avtar": {
    width: "100%",
    height: "100%",
  },
  "& .opacity-0": {
    opacity: 0,
  },
  "& .opacity-1": {
    opacity: 1,
    backgroundColor: "rgba(15, 23, 42, 0.6) !important",
    color: "#fff",
  },
  "& .update-btn": {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    padding: "8px 24px",
    backgroundColor: colors.primary,
    color: "#fff",
    boxShadow: "0 4px 12px rgba(127, 29, 29, 0.25)",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      boxShadow: "0 6px 16px rgba(127, 29, 29, 0.35)",
      transform: "translateY(-1px)",
    },
  },
  "& .cancel-btn": {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    padding: "8px 24px",
    backgroundColor: "#ffffff",
    color: "#475569",
    border: "1px solid #cbd5e1",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#f1f5f9",
      borderColor: "#94a3b8",
      color: "#1e293b",
    },
  },
}));

export const UploadBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  fontSize: "0.75rem",
}));

export const UploadResumeContainer = styled(Box)(({ theme }) => ({
  marginBottom: "1rem",
  paddingTop: "1rem",
}));

export const UploadJDContainer = styled(Box)(({ theme }) => ({
  marginBottom: "1rem",
}));

export const CustomPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: "center",
  backgroundColor: "#ffffff",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.04)",
  border: "1px solid #e2e8f0",
  borderRadius: "16px",
}));

export const RightSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3.5),
  backgroundColor: "#ffffff",
  fontFamily: "inherit",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.04)",
  border: "1px solid #e2e8f0",
  borderRadius: "16px",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#cbd5e1",
      borderRadius: "10px",
      transition: "border-color 0.2s ease-in-out",
    },
    "&:hover fieldset": {
      borderColor: colors.primaryLightBorder,
    },
    "&.Mui-focused fieldset": {
      borderColor: `${colors.primary} !important`,
    },
  },
  "& .MuiFormLabel-root.Mui-focused": {
    color: `${colors.primary} !important`,
    fontWeight: 600,
  },
  "& .MuiFormLabel-root": {
    color: "#64748b",
  },
  "& .react-datepicker-wrapper": {
    width: "100%",
  },
  "& .react-datepicker__input-container > input": {
    borderRadius: "10px",
    border: "1px solid #cbd5e1",
    width: "100%",
    padding: "16.5px 14px",
    fontSize: "0.95rem",
    boxSizing: "border-box",
    fontFamily: "inherit",
    outline: "none",
    transition: "border-color 0.2s ease-in-out",
    ":focus": {
      borderColor: colors.primary,
      boxShadow: `0 0 0 3px ${colors.primaryLight}`,
    },
    "::placeholder": {
      color: "#94a3b8",
      fontSize: "0.95rem",
    },
  },
}));

export const CustomPhoneInput = styled(PhoneInput)(({ theme }) => ({
  border: "1px solid #cbd5e1",
  borderRadius: "10px",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    borderColor: colors.primaryLightBorder,
  },
  "&:focus-within": {
    borderColor: `${colors.primary} !important`,
    boxShadow: `0 0 0 3px ${colors.primaryLight}`,
  },
  "& .flag-dropdown": {
    borderRadius: "10px 0 0 10px",
    border: "none",
    backgroundColor: "#f8fafc",
  },
  "& .selected-flag:hover": {
    backgroundColor: "#f1f5f9 !important",
  },
  "& .form-control": {
    height: "55px",
    borderRadius: "10px",
    border: "none",
    fontSize: "0.95rem",
  },
}));

